export default () => {
  const horizontalGalleries = document.querySelectorAll('.horizontal-gallery');

  horizontalGalleries.forEach(( element ) => {
    element.querySelector('.horizontal-gallery__pause-js').addEventListener('click', () => {
      element.classList.toggle('horizontal-gallery__animation--paused');
      element.querySelectorAll('.horizontal-gallery__button-icon').forEach(( icon ) => {
        icon.classList.toggle('horizontal-gallery__button-icon--hidden');
      });
    });
  });
};
